const mobileBreakpoint = 768;

export const isScreenSizeMobile = (): boolean => {
  return window.innerWidth < mobileBreakpoint;
};
